const dashboardKeys = {
  all: ['dashboard'] as const,
  summary: (dateRange?: { from?: Date; to?: Date }) =>
    [...dashboardKeys.all, 'summary', dateRange] as const,
  proposalStats: (dateRange?: { sentAtFrom?: Date; sentAtTo?: Date }) =>
    [...dashboardKeys.all, 'proposalStats', dateRange] as const,
  invoiceStats: (dateRange?: { sentAtFrom?: Date; sentAtTo?: Date }) =>
    [...dashboardKeys.all, 'invoiceStats', dateRange] as const,
};

export default dashboardKeys;
